import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import { 
    allStudents,
    editORTDrivingTest,
 } from 'Actions';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student:this.props.data.student, 
            seldate:new Date(this.props.data.seldate), 
            sepmore:this.props.data.sepmore,
            formValues: this.props.data.formValues,
            olddate:this.props.data.seldate,
            loader:false,
            editable: {},
            keycode:'',
        };

        this.handleChange = this.handleChange.bind(this);
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });        
    }    

    addHandleSubmit(event) {
        event.preventDefault();
        const { formValues } = this.state;
      
        const isAnyRowFilled = formValues.every((row) => {
          return (
            row.right !== '' ||
            row.left !== '' 
          );
        });
      
        if (isAnyRowFilled) {
          this.setState({ loader: true });
          const sepmore = this.state.sepmore;
          const olddate = this.state.olddate;
          this.props.editORTDrivingTest(event, sepmore, olddate).then((data) => {
            this.setState({ loader: false });
          });
          setTimeout(() => {
            this.props.onClick();
        }, 2000);
        } else {
          alert('Please fill at least one of the fields (RIGHT and LEFT');
        }
      }
      
    
    addFormFields() {
        var chktotal=this.state.sepmore;
        var totalsep=chktotal+1;
        this.setState(({
          sepmore:totalsep,  
          formValues: [...this.state.formValues, { club:"", right : "", left : "", fairway : "", area:"", contact:"", missedgreen : "0", process:"0"}]
        }))
    }
    
    removeFormFields(i) {
        let formValues = this.state.formValues;
        var chktotal=this.state.sepmore;
        var totalsep=chktotal-1;
        formValues.splice(i, 1);
        this.setState({ formValues, sepmore:totalsep });
    }

    handleNumberic(e) {    
        if (!/[0-9,.]/.test(e.key)) {
            e.preventDefault();
        }        
    }

    checkkey(e){
       this.setState({keycode:e.key });
    }

    handleChange(i, e) {
            var keyval=this.state.keycode;
            let formValues = this.state.formValues; 
            var inputval=e.target.value;
            var digit=this.digits_count(inputval);

            if(e.target.name=='right'){            
                if(inputval==''){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['left_'+i]: !editable['left_'+i] }
                    }));
                }else if(digit==1&&keyval=='Backspace'){

                }else if(digit==1){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['left_'+i]: !editable['left_'+i] }
                    }));  
                } 
                formValues[i][e.target.name] = e.target.value; 
                this.setState({ formValues }); 
            }else if(e.target.name=='left'){                               
                if(inputval==''){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['right_'+i]: !editable['right_'+i] }
                    }));
                }else if(digit==1&&keyval=='Backspace'){

                }else if(digit==1){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['right_'+i]: !editable['right_'+i] }
                    }));  
                }
                formValues[i][e.target.name] = e.target.value; 
                this.setState({ formValues }); 
            }else if(e.target.name=='fairway'){
                var checkval=e.target.value;
                if(checkval==1){
                    formValues[i][e.target.name] = 0; 
                    this.setState({ formValues }); 
                }else{
                    formValues[i][e.target.name] = 1; 
                    this.setState({ formValues }); 
                }
            
            }else{
                formValues[i][e.target.name] = e.target.value; 
                this.setState({ formValues }); 
            }

        

        // outside range
        if(e.target.name=='right'){
            var rightval=formValues[i]['right'];
            var shortval=formValues[i]['short'];
            var longval=formValues[i]['long'];

            if(shortval!=""&&rightval!=""){
               this.calculateOutsideRange(rightval,shortval,i);
            }else if(longval!=""&&rightval!=""){
               this.calculateOutsideRange(rightval,longval,i);
            }

        }else if(e.target.name=='left'){
            var leftval=formValues[i]['left'];
            var shortval=formValues[i]['short'];
            var longval=formValues[i]['long'];

            if(shortval!=""&&leftval!=""){
                this.calculateOutsideRange(leftval,shortval,i);
            }else if(longval!=""&&leftval!=""){
                this.calculateOutsideRange(leftval,longval,i); 
            }

        }else if(e.target.name=='short'){
            var shortval=formValues[i]['short'];
            var rightval=formValues[i]['right'];
            var leftval=formValues[i]['left'];

            if(rightval!=""&&shortval!=""){
                this.calculateOutsideRange(shortval,rightval,i);
            }else if(leftval!=""&&shortval!=""){
                this.calculateOutsideRange(shortval,leftval,i);
            }

        }else if(e.target.name=='long'){
            var longval=formValues[i]['long'];
            var rightval=formValues[i]['right'];
            var leftval=formValues[i]['left'];

            if(rightval!=""&&longval!=""){
                this.calculateOutsideRange(longval,rightval,i);
            }else if(leftval!=""&&longval!=""){
                this.calculateOutsideRange(longval,leftval,i);
            }
        }    

    }

    digits_count(n) {
        var count = 0;
        if (n >= 0.1) ++count;
      
        while (n / 10 >= 1) {
          n /= 10;
          ++count;
        }      
        return count;
    }

    calculateOutsideRange(a, b, indx){
        let formValues = this.state.formValues;
        var checkboxval=formValues[indx]['missedgreen'];
        var c=a*a + b*b;        
        var total=Math.sqrt(a*a + b*b);
        
        if(total>='31'){
            if(checkboxval==0){
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['missedgreen_'+indx]: !editable['missedgreen_'+indx] }
                }));
                formValues[indx]['missedgreen'] = 1; 
            }
            this.setState({ formValues });
        }else{            
            
            if(checkboxval==1){
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['missedgreen_'+indx]: !editable['missedgreen_'+indx] }
                }));
            }
            formValues[indx]['missedgreen'] = 0; 
            this.setState({ formValues });
        }
    }

    handleChangeRadio(val, e){
        
        let formValues = this.state.formValues;
        var radval=e.target.value;
        formValues[val]['process'] = radval; 
        this.setState({ formValues });
    }    


render() {

    const { studentlists, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });

      return(
        <div>
             <div className="col-lg-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-lg-12" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Edit Driving Test">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-lg-4"> 
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                </FormGroup>
                                        </div> 
                                        
                                        <div className="col-sm-12 col-lg-4">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        selectsEnd
                                                        maxDate={new Date()} 
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div> 
                                         
                                        <div className="col-sm-12 col-lg-12"> 
                                            <div className="form-group">
                                                <div className="table-responsive">
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow hover>   
                                                                <TableCell align="center" width={'15%'}>CLUB USED</TableCell>
                                                                <TableCell align="center" width={'10%'}>LEFT (YDS)</TableCell>
                                                                <TableCell align="center" width={'10%'}>RIGHT (YDS)</TableCell>
                                                                <TableCell align="center" width={'10%'}>CONTACT</TableCell> 
                                                                <TableCell align="center" width={'10%'}>FAIRWAY</TableCell>  
                                                                <TableCell align="center" width={'10%'}>PROCESS</TableCell>
                                                                <TableCell align="center" width={'10%'}>DELETE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                        {this.state.formValues.map((element, i) => (
                                                             
                                                            <TableRow key={i}>
                                                             <TableCell>
                                                                <select  name="club" id={"club_"+i}  className="form-control form-control-alternative" 
                                                                value={element.club || ""} onChange={e => this.handleChange(i, e)} required>
                                                                    <option value=""> </option>
                                                                    <option value="1">Driver</option>
                                                                    <option value="2">3.W</option> 
                                                                    <option value="3">5.W</option> 
                                                                    <option value="4">Hybrid</option>                                             
                                                                </select>
                                                            </TableCell>                                                            
                                                            <TableCell><input type="text" name={'left'} id={'left_'+i} value={element.left || ""} disabled={(element.disleft==0)?!this.state.editable['left_'+i]:this.state.editable['left_'+i]} onKeyPress={e => this.handleNumberic(e)} onKeyDown={e => this.checkkey(e)} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                            <TableCell><input type="text" name={'right'} id={'right_'+i} value={element.right || ""} disabled={(element.disright==0)?!this.state.editable['right_'+i]:this.state.editable['right_'+i]} onKeyPress={e => this.handleNumberic(e)} onKeyDown={e => this.checkkey(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                            <TableCell>
                                                                <select  name="contact" id={"contact_"+i}  className="form-control form-control-alternative" 
                                                                value={element.contact || ""} onChange={e => this.handleChange(i, e)} required>
                                                                    <option value=""> </option>
                                                                    <option value="1">Good</option>
                                                                    <option value="2">Bad</option>                                            
                                                                </select>
                                                            </TableCell>  
                                                            <TableCell><input type="checkbox" name={'fairway'} id={'fairway_'+i} value={element.fairway} defaultChecked={element.fairway==1?true:false} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative"/></TableCell>                                                           
                                                            
                                                            <TableCell>
                                                            <div onChange={e => this.handleChangeRadio(i, e)} style={{textAlign:"center"}}>
                                                                <input type="radio" value="1" name={'ysnoprocess_'+i} defaultChecked={element.disradio==1?'checked':''} required/> Yes 
                                                                <input type="radio" value="0" name={'ysnoprocess_'+i} defaultChecked={element.disradio==0?'checked':''} style={{marginLeft:"10px"}} /> No
                                                                <input type="hidden" value={element.process} name="process" id={'process_'+i} />
                                                            </div>
                                                            </TableCell>
                                                            <TableCell>
                                                                    <IconButton style={{ width: "10px", height: "10px"}} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(i)}  > <DeleteOutlineOutlinedIcon/></IconButton> 
                                                                   
                                                            </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        </TableBody>
                                                    </Table>   
                                                </div>  
                                            </div>      
                                        </div>   
                                        <div className="col-lg-12">
                                            <div className="dd">
                                                <button  className="mr-3 mb-3 btn btn-outline-primary btn-sm float-right" type="button" onClick={() => this.addFormFields()}> <i class="zmdi zmdi-plus-circle-o"></i> add shot</button>
                                            </div>
                                        </div>                                     

                                       <div className="col-lg-12">
                                        <div className="form-group"> 
                                            <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader}>Update</button>  
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                    </div>
                    {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                    }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { studentlists, loading } = mostlyused;
    return { studentlists, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    editORTDrivingTest,
})(EditItems);
